import EditableField from 'components/EditableField'
import { Typography } from 'gu-ui-kit'
import React from 'react'
import PropTypes from 'prop-types'

export const NameCell = ({ handleChangeName, name, id }) => (
  <>
    <EditableField name={name} login={name} id={id} apply={handleChangeName}>
      <Typography
        variant={'Body-Forms-15'}
        color={'Label-Fifth'}
        component={'div'}
      >
        {name}
      </Typography>
    </EditableField>
    <Typography variant={'Body-10'} component={'div'} color={'Label-Secondary'}>
      id:{id}
    </Typography>
  </>
)

NameCell.propTypes = {
  handleChangeName: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.number,
}
